import type { ReactNode } from 'react';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, subtitle, children }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950 pt-32 pb-16 md:pt-40 md:pb-24">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(oklch(var(--background-50)) 1px, transparent 1px), linear-gradient(90deg, oklch(var(--background-50)) 1px, transparent 1px)',
          backgroundSize: '56px 56px',
        }}
      />
      <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 left-1/4 h-80 w-80 rounded-full bg-accent-500/10 blur-3xl" />

      <div className="relative mx-auto w-full max-w-content px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-primary-300">
            <span className="h-px w-8 bg-primary-400" />
            {eyebrow}
          </span>
          <h1 className="mt-5 text-3xl font-bold leading-[1.1] text-background-50 md:text-5xl">{title}</h1>
          {subtitle && (
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">{subtitle}</p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
}